export const dashboard = {
  ICON_REFRESH: 'fa fa-refresh',
  ICON_PLAY: 'fa fa-play',
  ICON_PAUSE: 'fa fa-pause',
  ICON_STOP: 'fa fa-stop',
  ICON_ANGLE_UP: 'fas fa-angle-up',
  ICON_ANGLE_DOWN: 'fas fa-angle-down',
};
